import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCookie = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.29035 10.8536C6.75739 12.0611 6.97885 13.4041 7.78499 13.8531C8.59113 14.3022 9.67669 13.6872 10.2096 12.4797C10.7426 11.2722 10.5211 9.92931 9.71501 9.48026C8.90886 9.0312 7.8233 9.64606 7.29035 10.8536Z",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.3727 18.5173C14.9182 19.3947 15.2409 20.4341 16.0936 20.8388C16.9463 21.2435 18.0061 20.8603 18.4606 19.9828C18.9152 19.1054 18.5925 18.066 17.7397 17.6613C16.887 17.2566 15.8272 17.6398 15.3727 18.5173Z",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 25.6667C7.55668 25.6667 2.33333 20.4433 2.33333 14C2.33333 7.55668 7.55668 2.33333 14 2.33333C14.282 2.33333 14.452 2.64081 14.3452 2.90184C14.1227 3.44627 14 4.04215 14 4.66667C14 7.244 16.0894 9.33333 18.6667 9.33333C19.3058 9.33333 19.9149 9.20486 20.4695 8.97232C20.7068 8.87289 21 9.07613 21 9.33333C21 11.2663 22.567 12.8333 24.5 12.8333C24.6328 12.8333 24.7638 12.826 24.8926 12.8115C25.2597 12.7706 25.6306 13.004 25.6501 13.3729C25.6611 13.5806 25.6667 13.7897 25.6667 14C25.6667 20.4433 20.4433 25.6667 14 25.6667Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4792 12.8333H16.3333M16.625 12.8333C16.625 12.9945 16.4944 13.125 16.3333 13.125C16.1722 13.125 16.0417 12.9945 16.0417 12.8333C16.0417 12.6722 16.1722 12.5417 16.3333 12.5417C16.4944 12.5417 16.625 12.6722 16.625 12.8333Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.47917 18.6667H9.33333M9.625 18.6667C9.625 18.8278 9.49442 18.9583 9.33333 18.9583C9.17225 18.9583 9.04167 18.8278 9.04167 18.6667C9.04167 18.5055 9.17225 18.375 9.33333 18.375C9.49442 18.375 9.625 18.5055 9.625 18.6667Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCookie;
